
    var riot = require('riot')
    //src: starling/src/tags/floating-r-line.html
riot.tag2('floating-r-line',
  '<popover ref="popover" closable="{false}" type="dark" title="Relationship line tool" size="small" position="above" riot-style="{getPopoverPosition()}"> <p class="popover_body_p" style="margin-bottom: 0;"> Drag endpoints to cards. </p> </popover> <div riot-style="{getFromHandlePosition()}" hide="{Boolean(fromNode)}" data-direction="from" class="link-handle-overlay from" title="Drag to position relationship" ondblclick="{handleDoubleClick}"></div> <div riot-style="{getToHandlePosition()}" hide="{Boolean(toNode)}" data-direction="to" class="link-handle-overlay to" title="Drag to position relationship" ondblclick="{handleDoubleClick}"></div> <svg class="floating-relationship"> <defs> <marker id="link-diamond" markerwidth="40" markerheight="40" refx="5" refy="5" orient="auto" markerunits="userSpaceOnUse" viewbox="-2 -2 20 20"> <path d="M 5,1 L 9,5 5,9 1,5 z" class="link-diamond-halo"></path> <path d="M 5,1 L 9,5 5,9 1,5 z" class="link-diamond"></path> </marker> </defs> <path ref="wrapper" riot-style="{getPathStyle()}" class="floating-relationship_wrapper" riot-d="{getLinePath()}"></path> <path id="floating-r-line" class="floating-relationship_path" riot-style="{getPathStyle()}" riot-d="{getLinePath()}" marker-start="url(#link-diamond)" marker-end="url(#link-diamond)"></path> <text> <textpath xlink:href="#floating-r-line" startoffset="100%"> <tspan x="-12" y="0" class="link-marker link-marker--ki">&#xe901;</tspan> </textPath> </text> </svg>',
  '',
  'hide="{isHidden}" class="floating-relationship_container"', function(opts) {
'use strict';

var _this = this;

var _interactjs = require('interactjs');

var _interactjs2 = _interopRequireDefault(_interactjs);

var _geom = require('lib/geom');

var _constants = require('lib/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _opts = opts,
    canvas = _opts.canvas;

canvas.floatingRLineTag = this;

this.isHidden = true;

this.resetPosition = function () {
  _this.fromPos = {
    top: 500,
    left: 500
  };

  _this.toPos = {
    top: 500,
    left: 1000
  };
};

this.resetPosition();

this.getLinePath = function () {
  var fromPoint = _this.fromPos;
  var toPoint = _this.toPos;

  if (_this.fromNode) {
    var fromNodeRect = _this.fromNode.refs.container.getBoundingClientRect();

    var relDragStartPoint = (0, _geom.findRelDragStartPoint)({
      fromNodeRect: fromNodeRect,
      toPoint: { x: _this.toPos.left, y: _this.toPos.top }
    });

    fromPoint = { left: relDragStartPoint.x, top: relDragStartPoint.y };
  } else if (_this.toNode) {
    var _fromNodeRect = _this.toNode.refs.container.getBoundingClientRect();

    var _relDragStartPoint = (0, _geom.findRelDragStartPoint)({
      fromNodeRect: _fromNodeRect,
      toPoint: { x: _this.fromPos.left, y: _this.fromPos.top }
    });

    toPoint = { left: _relDragStartPoint.x, top: _relDragStartPoint.y };
  };

  var _movePointTowardsPoin = (0, _geom.movePointTowardsPoint)({
    subject: {
      y: toPoint.top,
      x: toPoint.left
    },
    object: {
      y: fromPoint.top,
      x: fromPoint.left
    },
    magnitude: 0
  }),
      top = _movePointTowardsPoin.y,
      left = _movePointTowardsPoin.x;

  toPoint = { top: top, left: left };

  return '\n        M ' + fromPoint.left + ' ' + fromPoint.top + ' L ' + toPoint.left + ' ' + toPoint.top + '\n      ';
};

this.on('mount', function () {
  (0, _interactjs2.default)(_this.refs.wrapper).draggable({
    onstart: function onstart(e) {
      console.log('start');
    },
    onmove: function onmove(e) {
      var dx = e.dx;
      var dy = e.dy;
      _this.fromPos.left += dx;
      _this.toPos.left += dx;
      _this.fromPos.top += dy;
      _this.toPos.top += dy;
      _this.update();
    },
    onend: function onend(e) {
      console.log('end');
    }
  });

  (0, _interactjs2.default)('.link-handle-overlay').draggable({
    onstart: function onstart(e) {
      canvas.linkDragging = true;
      canvas.refs.canvas.classList.add('r-line-creating');
      _this.prevFromPos = _this.fromPos;
      _this.prevToPos = _this.toPos;
      _this.draggingEndpoint = e.target.classList.contains('from') ? 'from' : 'to';
    },
    onmove: function onmove(e) {
      e.preventDefault();
      e.stopPropagation();
      var newPos = {
        top: e.clientY,
        left: e.clientX
      };

      if (_this.draggingEndpoint === 'from') {
        _this.fromPos = newPos;
      } else {
        _this.toPos = newPos;
      }
      _this.update();
    },
    onend: function onend(e) {
      e.stopPropagation();
      e.stopImmediatePropagation();
      canvas.refs.canvas.classList.remove('r-line-creating');
      canvas.linkDragging = false;

      if (canvas.mouseEnteredNode) {
        if (_this.draggingEndpoint === 'to') {
          _this.toNode = canvas.mouseEnteredNode;
        } else {
          _this.fromNode = canvas.mouseEnteredNode;
        }
      }

      _this.update();
    }
  });
});

this.on('updated', function () {
  if (_this.toNode && _this.fromNode) {
    var lastCurvature = localStorage.getItem(window.map_id + '-last-line-curvature') || 'arc';
    var link = {
      fromNodeId: _this.fromNode.id,
      toNodeId: _this.toNode.id,
      lineCurvature: lastCurvature,
      direction: 'right',
      createdById: window.user_id
    };
    var fromNode = _this.fromNode;
    var toNode = _this.toNode;
    _this.fromNode = null;
    _this.toNode = null;
    link.id = store.addLink(link);
    canvas.update();
    canvas.setLinkDragging(false);
    canvas.linksTag.update();
    toNode.rediscoverLinkPositions();

    var linkTag = canvas.getLinkTag(link);

    if (linkTag) {
      canvas.setSelectedElements([linkTag]);
    }

    var messages = [];
    messages.push(canvas.operation.messages.addLink({ link: link }));
    canvas.operation.batchOperation({
      messages: messages,
      onFailure: function onFailure(err) {
        return console.log('batch operation failure: ' + err);
      }
    });
    _this.hide();
  }
});

this.summon = function (_ref) {
  var fromNode = _ref.fromNode,
      toNode = _ref.toNode,
      toPos = _ref.toPos,
      fromPos = _ref.fromPos;

  _this.resetPosition();
  _this.fromNode = fromNode || null;
  _this.toNode = toNode || null;
  document.addEventListener('keyup', _this.handleKeyup);
  if (toPos) {
    _this.toPos = toPos;
  }
  if (fromPos) {
    _this.fromPos = fromPos;
  }

  _this.isHidden = false;

  if (window.user && (!window.user.seen_r_line_tooltip || window.user.seen_r_line_tooltip < 3)) {
    _this.refs.popover.show();
    if (window.user.seen_r_line_tooltip) {
      window.user.seen_r_line_tooltip += 1;
    } else {
      window.user.seen_r_line_tooltip = 1;
    }
    $.ajax({
      method: 'POST',
      url: '/api/users/display-flags/update',
      data: { seen_r_line_tooltip: window.user.seen_r_line_tooltip }
    });
  }
  _this.update();
};

this.handleKeyup = function (e) {
  var DELETE = _constants.KEY_CODES.DELETE,
      BACKSPACE = _constants.KEY_CODES.BACKSPACE,
      ESCAPE = _constants.KEY_CODES.ESCAPE;

  var dismissKeys = [DELETE, BACKSPACE, ESCAPE];

  if (dismissKeys.includes(e.keyCode)) {
    _this.hide();
  }
};

this.hide = function () {
  _this.fromNode = null;
  _this.toNode = null;
  _this.isHidden = true;
  if (_this.refs.popover) {
    _this.refs.popover.hide();
  }
  document.removeEventListener('keyup', _this.handleKeyup);
  _this.update();
};

this.getFromHandlePosition = function () {
  return '\n        top: ' + _this.fromPos.top + 'px;\n        left: ' + _this.fromPos.left + 'px;\n        pointer-events: ' + (canvas.linkDragging ? 'none' : 'all') + ';\n      ';
};

this.getToHandlePosition = function () {
  return '\n        top: ' + _this.toPos.top + 'px;\n        left: ' + _this.toPos.left + 'px;\n        pointer-events: ' + (canvas.linkDragging ? 'none' : 'all') + ';\n      ';
};

this.getPopoverPosition = function () {
  if (_this.toNode) {
    return '\n          top: ' + (_this.fromPos.top - 40) + 'px;\n          left: ' + (_this.fromPos.left - 5) + 'px;\n        ';
  } else {
    return '\n          top: ' + (_this.toPos.top - 40) + 'px;\n          left: ' + (_this.toPos.left - 5) + 'px;\n        ';
  }
};

this.getPathStyle = function () {
  return 'pointer-events: ' + (canvas.linkDragging ? 'none' : 'all');
};

this.handleDoubleClick = function (e) {
  e.stopPropagation();

  var _canvas$createNodeOnD = canvas.createNodeOnDblClick(e, false, true, true),
      newNode = _canvas$createNodeOnD.nodeTag;

  if (e.target.getAttribute('data-direction') === 'to') {
    _this.toNode = newNode;
  } else {
    _this.fromNode = newNode;
  }
  _this.update();
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('floating-r-line')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/floating-r-line.html
// module id = 753
// module chunks = 0